import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ref, get, update } from 'firebase/database';
import { database } from '../../services/firebase';
import { generateAptitudeQuestions } from '../../services/geminiService';
import Swal from 'sweetalert2';


const AptitudeTest = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes
  const userId = localStorage.getItem('userId');
  const [isStarted, setIsStarted] = useState(false);
  const [jobData, setJobData] = useState(null);
  const [generatingQuestions, setGeneratingQuestions] = useState(false);
  const [tabSwitchCount, setTabSwitchCount] = useState(0);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // alert('⚠️ Warning: Please do not switch tabs during the test!');
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: '⚠️ Warning: Please do not switch tabs during the test!',
        });
        setTabSwitchCount(prev => prev + 1);
      }
    };
  
    document.addEventListener('visibilitychange', handleVisibilityChange);
  
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  
  useEffect(() => {
    if (tabSwitchCount >= 3) {
      // alert('❌ You switched tabs multiple times. The test is now terminated.');
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: '❌ You switched tabs multiple times. The test is now terminated.',
      });
      handleSubmit(); // Auto-submit or terminate the test
    }
  }, [tabSwitchCount]);
  
  // Move all useEffect hooks to the top level
  // Remove question generation from initial load
  useEffect(() => {
    const fetchJobData = async () => {
      if (!jobId) {
        alert('Invalid job ID');
        navigate(-1);
        return;
      }

      try {
        setLoading(true);
        const jobRef = ref(database, 'Joblisting1');
        const snapshot = await get(jobRef);
        
        if (!snapshot.exists()) {
          throw new Error('No jobs found in database');
        }

        const companies = snapshot.val();
        const techCorpData = companies.TechCorp;

        if (!techCorpData) {
          throw new Error('Company data not found');
        }

        setJobData(techCorpData);
      } catch (error) {
        console.error('Error:', error);
        alert(error.message || 'Error loading test data');
        navigate(-1);
      } finally {
        setLoading(false);
      }
    };

    fetchJobData();
  }, [jobId, navigate]);

  // const startTest = async () => {
  //   try {
  //     setGeneratingQuestions(true);
  //     // Ensure requirements is properly formatted as an array
  //     const requirements = jobData.requirements || '';
  //     const requirementsArray = requirements.split(',').map(req => req.trim());
      
  //     // Simplified prompt structure
  //     const prompt = {
  //       position: jobData.position,
  //       companyName: jobData.Company_name,
  //       requirements: requirementsArray,
  //       description: jobData.description
  //     };
      
  //     const generatedQuestions = await generateAptitudeQuestions(prompt);
  //     console.log("Generated questions:", generatedQuestions);
      
  //     if (!generatedQuestions || generatedQuestions.length === 0) {
  //       throw new Error('Failed to generate questions');
  //     }

  //     setQuestions(generatedQuestions);
  //     setIsStarted(true);
  //     setTimeLeft(30 * 60);
  //   } catch (error) {
  //     console.error('Error:', error);
  //     alert('Failed to generate questions. Please try again.');
  //   } finally {
  //     setGeneratingQuestions(false);
  //   }
  // };
  const startTest = async () => {
    try {
      setGeneratingQuestions(true);
      // Ensure requirements is properly formatted as an array
      const requirements = jobData.requirements || '';
  
      // Fix: Check if requirements is a string
      const requirementsArray = Array.isArray(requirements)
        ? requirements
        : typeof requirements === 'string'
        ? requirements.split(',').map(req => req.trim())
        : [];
  
      // Simplified prompt structure
      const prompt = {
        position: jobData.position,
        companyName: jobData.Company_name,
        requirements: requirementsArray,
        description: jobData.description
      };
  
      const generatedQuestions = await generateAptitudeQuestions(prompt);
      console.log('Generated questions:', generatedQuestions);
  
      if (!generatedQuestions || generatedQuestions.length === 0) {
        throw new Error('Failed to generate questions');
      }
  
      setQuestions(generatedQuestions);
      setIsStarted(true);
      setTimeLeft(30 * 60);
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to generate questions. Please try again.');
    } finally {
      setGeneratingQuestions(false);
    }
  };
  
  useEffect(() => {
    if (timeLeft > 0 && isStarted) {
      const timer = setInterval(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (timeLeft === 0 && isStarted) {
      handleSubmit();
    }
  }, [timeLeft, isStarted]);  const renderStartScreen = () => {
     return (
      <div className="max-w-4xl mx-auto p-8">
        <div className="bg-white rounded-2xl shadow-2xl p-10">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-3">
              Technical Aptitude Test
            </h1>
            <h2 className="text-xl text-indigo-600 font-semibold mb-2">
              {jobData?.position} at {jobData?.Company_name}
            </h2>
            <div className="w-24 h-1 bg-indigo-600 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              This assessment will evaluate your technical knowledge and problem-solving skills
              relevant to the position. Please ensure you're in a quiet environment before starting.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-gray-50 rounded-xl p-6 text-center">
              <div className="text-indigo-600 text-2xl font-bold mb-2">30</div>
              <div className="text-gray-600">Minutes</div>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 text-center">
              <div className="text-indigo-600 text-2xl font-bold mb-2">15</div>
              <div className="text-gray-600">Questions</div>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 text-center">
              <div className="text-indigo-600 text-2xl font-bold mb-2">10</div>
              <div className="text-gray-600">Passing Score</div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-6 mb-8">
            <h3 className="text-lg font-semibold mb-4">Important Instructions:</h3>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-center">
                <span className="w-2 h-2 bg-indigo-600 rounded-full mr-3"></span>
                Ensure stable internet connection throughout the test
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-indigo-600 rounded-full mr-3"></span>
                Answer all questions within the time limit
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-indigo-600 rounded-full mr-3"></span>
                You can review and change answers before final submission
              </li>
            </ul>
          </div>

          <div className="text-center">
            <button
              onClick={startTest}
              disabled={generatingQuestions}
              className={`px-10 py-4 rounded-xl text-lg font-semibold transition-all duration-200 ${
                generatingQuestions 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg transform hover:-translate-y-1'
              } text-white flex items-center justify-center mx-auto`}
            >
              {generatingQuestions ? (
                <>
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-3"></div>
                  Preparing Your Test...
                </>
              ) : (
                'Begin Test'
              )}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleAnswer = (questionId, answer) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answer
    }));
  };

  const handleSubmit = async () => {
    try {
      const score = questions.reduce((acc, q) => {
        return acc + (answers[q.id] === q.correctAnswer ? 1 : 0);
      }, 0);
  
      const passed = score >= 10;
      const testDate = new Date().toISOString();
  
      if (!jobData || !jobData.Company_name) {
        throw new Error('Missing job data');
      }
  
      // Create aptitude test result object
      const aptitudeTestResult = {
        companyName: jobData.Company_name || 'Unknown Company',
        score: score || 0,
        passed: passed || false,
        completedAt: testDate,
        totalQuestions: questions.length || 0,
        correctAnswers: score || 0,
        testDuration: '30 minutes'
      };
  
      // Update user's application data
      const userRef = ref(database, `users/${userId}`);
      const snapshot = await get(userRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const applications = userData.applications || {};
        const appKey = Object.keys(applications).find(
          key => applications[key].jobId === parseInt(jobId)
        );
  
        if (appKey && passed) {
          const updates = {};
          
          // Existing updates
          updates[`users/${userId}/applications/${appKey}/testStatus`] = {
            completed: true,
            score,
            passed,
            completedAt: testDate
          };
          
          // Add logical test scheduling
          updates[`users/${userId}/applications/${appKey}/logicalTest`] = {
            scheduled: true,
            question: "How would you cut a cake into 8 equal pieces using only 3 cuts?",
            status: 'pending',
            scheduledAt: testDate
          };
  
          // Add notification for recruiter
          const notificationId = Date.now().toString();
          updates[`notifications/${jobData.Company_name.toLowerCase()}`] = {
            [notificationId]: {
              type: 'aptitude_test_passed',
              userId,
              jobId,
              message: `Candidate has passed the aptitude test with score ${score}/15`,
              timestamp: testDate,
              status: 'unread',
              nextStep: 'logical_test'
            }
          };
  
          // Update all data
          await update(ref(database), updates);
  
          // Show success message to user
          Swal.fire({
            icon: 'success',
            title: 'Congratulations!',
            text: 'You have passed the aptitude test. Please proceed to the logical reasoning test.',
            confirmButtonText: 'Continue to Logical Test'
          }).then((result) => {
            if (result.isConfirmed) {
              navigate('/logical-test', {
                state: { 
                  jobId,
                  companyName: jobData.Company_name,
                  aptitudeScore: score
                }
              });
            }
          });
        } else {
          // Existing navigation code for non-passing cases
          navigate('/dashboard/user', { 
            state: { 
              testCompleted: true, 
              score, 
              passed,
              message: `Test completed! Score: ${score}/15 ${passed ? '(Passed)' : '(Failed)'}`
            } 
          });
        }
      }
    } catch (error) {
      console.error('Error saving test results:', error);
      alert('Error saving your test results. Please try again.');
    }
  };

  // Render logic
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!isStarted) {
    return renderStartScreen();
  }

  return (
    <div className="max-w-4xl mx-auto p-8 min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Technical Assessment</h1>
          <p className="text-indigo-600">{jobData?.position} Position</p>
        </div>
        <div className="text-center bg-indigo-50 px-6 py-3 rounded-xl">
          <div className="text-2xl font-bold text-indigo-600">
            {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}
          </div>
          <div className="text-sm text-gray-600">Time Remaining</div>
        </div>
      </div>

      {/* Question Card */}
      <div className="bg-white rounded-2xl shadow-lg p-8">
        {/* Progress Bar */}
        <div className="mb-6">
          <div className="flex justify-between text-sm text-gray-600 mb-2">
            <span>Progress</span>
            <span>{currentQuestion + 1} of {questions.length}</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div 
              className="bg-indigo-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${((currentQuestion + 1) / questions.length) * 100}%` }}
            ></div>
          </div>
        </div>

        {/* Question Text */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            {questions[currentQuestion]?.text}
          </h2>
        </div>

        {/* Options */}
        <div className="space-y-4 mb-8">
          {questions[currentQuestion]?.options.map((option, index) => (
            <button
              key={index}
              onClick={() => handleAnswer(questions[currentQuestion].id, option)}
              className={`w-full p-4 text-left rounded-xl transition-all duration-200 border-2 
                ${answers[questions[currentQuestion].id] === option
                  ? 'border-indigo-600 bg-indigo-50 text-indigo-900'
                  : 'border-gray-200 hover:border-indigo-300 hover:bg-indigo-50'
                } flex items-center group`}
            >
              <span className={`w-8 h-8 rounded-full mr-4 flex items-center justify-center text-sm
                ${answers[questions[currentQuestion].id] === option
                  ? 'bg-indigo-600 text-white'
                  : 'bg-gray-100 group-hover:bg-indigo-100'
                }`}>
                {String.fromCharCode(65 + index)}
              </span>
              <span className="flex-1">{option}</span>
            </button>
          ))}
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-between items-center pt-6 border-t border-gray-200">
          <button
            onClick={() => setCurrentQuestion(prev => Math.max(0, prev - 1))}
            disabled={currentQuestion === 0}
            className={`px-6 py-3 rounded-xl flex items-center space-x-2 transition-all
              ${currentQuestion === 0
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
              }`}
          >
            <span>←</span>
            <span>Previous</span>
          </button>
          
          {currentQuestion < questions.length - 1 ? (
            <button
              onClick={() => setCurrentQuestion(prev => prev + 1)}
              className="px-6 py-3 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 
                transition-all flex items-center space-x-2"
            >
              <span>Next</span>
              <span>→</span>
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              className="px-6 py-3 rounded-xl bg-green-600 text-white hover:bg-green-700 
                transition-all flex items-center space-x-2"
            >
              <span>Submit Test</span>
              <span>✓</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AptitudeTest;